// extracted by mini-css-extract-plugin
export default {"card":"panel_card__A2wap","header":"panel_header__-DttM"};